import { Helmet } from 'react-helmet-async';

const SCHEMA_TYPE_BY_INDUSTRY: Record<string, string> = {
  beauty:      'BeautySalon',
  nail:        'BeautySalon',
  barbershop:  'BarberShop',
  spa:         'DaySpa',
  fitness:     'ExerciseGym',
  psychology:  'Psychologist',
  nutrition:   'Dietitian',
  veterinary:  'VeterinaryCare',
  dental:      'Dentist',
  medical:     'MedicalClinic',
};

interface SchemaOrgProps {
  industryType?: string | null;
  name: string;
  url: string;
  telephone?: string | null;
  address?: string | null;
  imageUrl?: string | null;
  openingHours?: Record<string, { open: string | null; close: string | null }>;
}

const DAY_ABBR: Record<string, string> = {
  monday:    'Mo',
  tuesday:   'Tu',
  wednesday: 'We',
  thursday:  'Th',
  friday:    'Fr',
  saturday:  'Sa',
  sunday:    'Su',
};

function buildOpeningHours(hours: Record<string, { open: string | null; close: string | null }>): string[] {
  return Object.entries(hours)
    .filter(([, h]) => h.open && h.close)
    .map(([day, h]) => `${DAY_ABBR[day] ?? day} ${h.open}-${h.close}`);
}

export function SchemaOrg({ industryType, name, url, telephone, address, imageUrl, openingHours }: SchemaOrgProps) {
  const schemaType = SCHEMA_TYPE_BY_INDUSTRY[industryType ?? ''] ?? 'LocalBusiness';

  const schema: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': schemaType,
    name,
    url,
  };

  if (telephone) schema.telephone = telephone;
  if (address) schema.address = { '@type': 'PostalAddress', streetAddress: address };
  if (imageUrl) schema.image = imageUrl;
  if (openingHours) {
    const specs = buildOpeningHours(openingHours);
    if (specs.length > 0) schema.openingHours = specs;
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
